import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {ListTitleIconDefaultBox} from "./list-title-icon.default.box";
import {ListTitleIconWsopCipBox} from "./list-title-icon.wsop.cip.box";
import {ListTitleIconCisBox} from "./list-title-icon.cis.box";

export const ListTitleIconBox = styledByTheme(ListTitleIconDefaultBox)
                                .forCis(ListTitleIconCisBox)
                                .forWsopCip(ListTitleIconWsopCipBox)
                                .apply();